import {
  Box,
  Button,
  Container,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Steeper from "./Steeper";
import Recap from "./Recap";
import { Link, Outlet, useNavigate } from "react-router-dom";
import RetraitInfo from "./RetraitInfo";
import Coordonnes from "./Coordonnes";
import { useSelector, useDispatch } from "react-redux";
import SteepReservation from "../home/SteepReservation";
import { Helmet } from "react-helmet-async";

function Reservation() {
  const [steep, setSteep] = useState(1);
  const state = useSelector((state) => state.change.value);
  const navigate = useNavigate();
  useEffect(() => {
    // Remettre le défilement en haut de la page à chaque chargement
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        pt: { xs: 4, sm: 8 },
        pb: { xs: 4, sm: 8 },
        pl: { xs: 4, sm: 8 },
        pr: { xs: 4, sm: 8 },
        mb: 4,
        background: "#ffdb02",
      }}
    >
      <Helmet>
        <title>Réservation de devise - EXCHANGE.COM</title>
        <meta
          name="description"
          content="EXCHANGE.COM propose des services fiables de change de devises à Marrakech et au Maroc. Échangez facilement des dirhams marocains (MAD) avec nous. Visitez notre site pour découvrir nos taux compétitifs et effectuer des transactions en toute simplicité."
        />
      </Helmet>
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          backgroundColor: "white",
          width: "88vw",
          color: "goldenrod",
          mb:2,
        }}
      >
        <Steeper steep={steep} />
      </Box>

      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: 2,
          width: { xs: "100vw", md: "88vw" },
          // padding: 4,
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            padding: 2,
            borderRadius: 2,
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap-reverse",
          }}
        >
          <Outlet />
        </Box>
        

          <Typography variant="h5" sx={{pl:2,color:"goldenrod"}}> EXCHANGE.COM</Typography>
<Typography
          variant="body2"
          // align='center'
          sx={{
            // fontSize: { xs: 16, sm: 16 },
            // color: "black",
            pl: 2,pb:2
          }}
        >
          Société de change agréée par les autorités. Nous respectons
          rigoureusement toutes les lois en vigueur concernant la protection des
          données de nos clients. Votre confidentialité et sécurité sont notre
          priorité absolue.
        </Typography>
      </Box>
    </Box>
  );
}

export default Reservation;
